<template>
  <div class="wrapper">
    <login-box @login="openReserveDialog" />
    <banner :video="videoSrc" :reserveCount="reserveCount" @reserve="openReserveDialog" />
    <div class="main">
      <news-module :newsPicList="newsPicList" />
      <reservation-module :giftData="reservationGiftsData" @reserve="openReserveDialog" @viewRule="openRuleDialog" v-if="stage == 0" />
      <download-module :giftData="downloadGiftsData" v-else-if="stage == 1" />
      <invitation-module :giftData="invitationGiftsData" :giftLog="invitationGiftsLog" @viewRule="openRuleDialog" @afterGetReward="getGiftData" @success="getGiftData" />
      <character-module :characterData="characterList" />
      <feature-module :featureData="featureList" />
      <social-module />
    </div>
    <pc-footer />
    <home-nav />
    <reserve-dialog @success="getGiftData" />
    <rule-dialog :visible.sync="ruleDialogVisible" :rule="activityRule" />
    <!-- <login-dialog @success="getGiftData" /> -->
    <tips-dialog />
  </div>
</template>

<script>
import LoginBox from './components/loginBox/Index.vue'
import Banner from './components/banner/Index.vue'
import NewsModule from './components/news/Index.vue'
import ReservationModule from './components/reservation/Index.vue'
import DownloadModule from './components/download/Index.vue'
import InvitationModule from './components/invitation/Index.vue'
import CharacterModule from './components/character/Index.vue'
import FeatureModule from './components/feature/Index.vue'
import SocialModule from './components/social/Index.vue'
import PcFooter from '@/views/pc/components/footer/Index.vue'
import HomeNav from './components/nav/Index.vue'
import TipsDialog from '@/views/pc/components/tipsDialog/Index.vue'
import ReserveDialog from '@/views/pc/components/reserveDialog/Index.vue'
import RuleDialog from '@/views/pc/components/ruleDialog/Index.vue'
// import LoginDialog from '@/views/pc/components/loginDialog/Index.vue'

import homeMixins from '@/mixins/home/homeMixins'

export default {
  name: 'PcHome',
  mixins: [homeMixins],
  components: {
    LoginBox,
    Banner,
    NewsModule,
    ReservationModule,
    DownloadModule,
    InvitationModule,
    CharacterModule,
    FeatureModule,
    SocialModule,
    PcFooter,
    HomeNav,
    TipsDialog,
    ReserveDialog,
    RuleDialog,
    // LoginDialog,
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 5986px;
  background: url('~@/assets/img/pc/body_bg.jpg') no-repeat;
  background-position: center;
}
</style>

<style lang="scss">
.wrapper {
  position: relative;
  max-width: 1920px;
  min-width: 1400px;
  overflow: hidden;
  width: 100%;
  background: #fff;
}

.module {
  position: relative;
  padding-top: 60px;

  &__title {
    width: 100%;
    height: 192px;
    background: url('~@/assets/img/pc/title.png') no-repeat;
    background-position: center;
  }
}
</style>